module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list', {
    staticClass: "pa-0",
    attrs: {
      "dense": "",
      "three-line": ""
    }
  }, [(_vm.request.loading) ? _c('v-progress-linear', {
    attrs: {
      "indeterminate": "",
      "height": 2
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.messages), function(comm) {
    return [_c('communication-list-item', {
      key: comm.id,
      attrs: {
        "item": comm
      }
    }), _vm._v(" "), _c('v-divider', {
      key: ("div" + (comm.id))
    })]
  }), _vm._v(" "), (!_vm.request.loading && _vm.messages && _vm.messages.length === 0) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n        " + _vm._s(_vm.$t('nomessages')) + "\n      ")])], 1)], 1) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-205e022b","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/lists/CommunicationList.vue
// module id = 1350
// module chunks = 9